'use client'
import Link from 'next/link';
import Image from '@/grandus-utils/wrappers/image/Image';
import isFunction from 'lodash/isFunction';
import { useTranslation } from 'react-i18next';
import Button from '@/components/_other/button/Button';
import ProductTitle from '@/app/components/product/card/ProductTitle';
import CardParameters from '@/app/components/product/cardParameters/CardParameters';
import { PRODUCT_ENQUIRY_HASH } from '@/constants/ProductConstants';

const ProductCard = ({ product, onClick }) => {
  const { t } = useTranslation();

  const linkProps = {
    href: `/produkt/${product?.urlTitle}`,
    'aria-label': `link to ${product?.name}`,
    title: product?.name ?? '',
  };

  if (isFunction(onClick)) {
    linkProps.onClick = onClick;
  }

  return (
    <div className={'relative group w-full'}>
      <Link
        {...linkProps}
        className={'absolute inset-0 z-10'}
      />

      <div className={'overflow-hidden border light:border-primary dark:border-white'}>
        <div className={'relative overflow-hidden'}>
          <Image
            photo={product?.photo}
            alt={product?.photo?.description || product?.name}
            useNextImage={true}
            type={'jpg'}
            width={'396'}
            height={'396'}
            suffix={'__cropped@2x'}
            usePlaceholder={true}
            className={'w-full h-auto group-hover:scale-105 transition-transform duration-500 object-cover'}
          />
        </div>
        <div className={'pt-8 pb-4 px-4 light:border-primary dark:border-white border-b-0'}>
          <div className={'uppercase text-lg line-clamp-3 xl:line-clamp-3 h-[72px] xl:h-[48px] leading-6'}>
            <ProductTitle product={product} />
          </div>
          <CardParameters product={product} isInline={true} className={'mt-2'} />
          <div className={'relative mt-6'}>
            <div className={'uppercase text-sm mb-12'}>
              {product?.storeStatus?.message}
            </div>

            <div className={'flex items-center h-[33px]'}>
              <div className={'basis-auto'}>
                <Button size="xsmall" htmlType="a" className={'relative z-20 dark:text-white text-sm'} {...linkProps}>{t('product.card.show_product')}</Button>
                {/*{product.isOrderable && !isEmpty(product.store) ? (*/}
                {/*  <Link*/}
                {/*    href={'#'}*/}
                {/*    className={'relative z-20 dark:text-white'}*/}
                {/*    onClick={handleClick}*/}
                {/*  >*/}
                {/*    {isLoading ? (*/}
                {/*      <LoadingIcon />*/}
                {/*    ) : (*/}
                {/*      <CartIcon className={'w-[33px] h-[33px]'} />*/}
                {/*    )}*/}
                {/*  </Link>*/}
                {/*) : (*/}
                {/*  ''*/}
                {/*)}*/}
              </div>
              <div className={'basis-full text-end text-lg md:text-xl'}>
                {product?.kind?.hash === PRODUCT_ENQUIRY_HASH
                  ? ''
                  : product?.finalPriceData?.priceFormatted}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
